var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBackArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5.335,
    height: 9.25,
    viewBox: "0 0 5.335 9.25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Back_arrow",
    "data-name": "Back arrow",
    d: "M4.5,3.493,7.9.184a.654.654,0,0,1,.908,0,.618.618,0,0,1,0,.885L4.957,4.818a.656.656,0,0,1-.887.018L.188,1.071a.616.616,0,0,1,0-.885.654.654,0,0,1,.908,0Z",
    transform: "translate(5.164 0.125) rotate(90)",
    fill: "#afafaf",
    stroke: "#afafaf",
    strokeWidth: 0.25
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBackArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_Back_arrow.a32f7a5fdf8b2de6dd78af5583e304da.svg";